'use es6';

export const languageI18nKey = key => `SharedI18nStrings.languageNames.${key}`;